/**
 * Created by tomers on 8/3/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var DateUtility = require("utils/DateUtility");

    var UserListComparators = [];

    function moduleDefinition (LEUserManagement, LE, Backbone, Marionette, $, _) {
        //I wish these comparators where mre straight forward, alas AS user Model,AC user model may have different property names
        UserListComparators = [
            {
                name:"displayName",
                func:function(model){
                    return model.getDisplayName().toLowerCase();
                }
            },
            {
                name:"userTypeId",
                func:function(model){
                    return LE.translator.translate("LEUserManagement.userEdit.userType." + model.getUserTypeKey());
                }
            },
            {
                name:"nickName",
                func:function(model){
                    return model.getNickName().toLowerCase();
                }
            },
            {
                name: "loginName",
                func: function(model) {
                    return model.getLoginName().toLowerCase();
                }
            },
            {
                name: "permissionGroup",
                func: function(model) {
                    var pGroup = model.getPermissionGroup();
                    if (_.isArray(pGroup)){     //ac user
                        return _.first(pGroup);
                    }else{
                        return pGroup;         //as user
                    }

                }
            },
            {
                name: "maxConversations",
                func: function(model){
                    var maxConversations = model.getMaxConversations();
                    if(_.isNull(maxConversations) || _.isUndefined(maxConversations)) {
                        var settingsCollection = LEUserManagement.getDataManager().getSiteSettingsUserList();
                        maxConversations = settingsCollection.get(settingsCollection.SETTINGS_ENUM.SETTING_ID.MAX_CONVERSATIONS).getValue();
                    }
                    return maxConversations;
                }
            }

        ];
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UserListComparators;
});
